<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ title }}</h2>
    </header>

    <list
      class="view__content"
      :data="entries()"
      :fields="headers()"
      :pagination="pagination"
      :progress-value="progressValue"
      :hideCreate="false"
      :hideSearch="false"
      :hideExport="false"
      :isLoading="isLoading"

      @action="action"
      @paginate="paginate"
      @search="search" />
  </article>
</template>

<script>
import L from 'services/Localization'
import List from "components/layout/list";
import { mapGetters } from "vuex";
import File from "services/File";
import _ from "lodash";

export default {
  name: "members-home",
  components: { List },
  beforeCreate() {
    this.$store.dispatch("getAllGroups").then(() => {
      this.$store.dispatch("setGroupForSearch", this.groups[0]);
      this.paginate(1);
    });
  },
  data() {
    return {
      L: L,
      title: L.localize('Members_Index_Title'),
      progressValue: 0,
      isLoading: true
    };
  },
  beforeDestroy() {
    this.$store.dispatch("getAllMembers", null);
  },
  computed: {
    ...mapGetters({
      groups: "allGroups",
      members: "allMembers",
      pagination: "allMembersPagination",
      group: "groupSearch"
    })
  },
  methods: {
    headers: function() {
      if (this.group !== undefined && this.group.properties !== undefined) {
        let displayable = this.group.properties.filter(
          property => property.displayInGrid
        );
        let properties = displayable.map(function(property) {
          return {
            prop: property.title,
            label: property.label
          };
        });
        return properties;
      }
      return [];
    },
    entries: function() {
      let self = this;
      return this.members.map(function(member) {
        let url = self.$router.resolve({
          name: "member-detail",
          params: { id: member.id }
        });
        return _.assign(JSON.parse(member.data), { id: member.id, __url: url.href });
      });
    },
    paginate(pageNumber, search) {
      if (this.group) {
        let self = this;

        let request = {
          groupId: this.group.id,
          page: pageNumber
        };

        if (search) {
          request.searchQuery = search.query;
          request.criterias = search.criterias;
        }

        this.isLoading = true;
        this.$store.dispatch("getAllMembers", request)
          .then(function() {
            self.isLoading = false;
          });
      } else {
        this.isLoading = false;
      }
    },
    search(search) {
      let request = {
        groupId: this.group.id,
        page: 1,
        searchQuery: search.query,
        criterias: search.criterias
      };
      this.$store.dispatch("getAllMembers", request);
    },
    action(command) {
      switch (command.name) {
        case "detail":
          this.$router.push({
            name: "member-detail",
            params: { id: command.item.id }
          });
          break;
        case "create":
          this.$router.push({ name: "member-create" });
          break;
        case "export":
          File.downloadWithQuery("/settings/import-export/export", {
            criterias: command.item.criterias,
            searchQuery: command.item.query
          });
          break;
      }
    },
    progressExport(e) {
      if (e.lengthComputable) {
        this.progressValue = e.loaded / e.total * 100;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// Members.vue?8e6ae9da